import Lottie from 'lottie-react';

import {useLoading} from '@/app/zustand/useLoading';
import ModakLoaderAnimation from '@/lotties/ModakLoader.json';

import './styles.scss';

export const ModakLoader = () => {
  const {isLoading} = useLoading();
  return (
    <>
      {isLoading && (
        <div className="full-screen-loader">
          <Lottie
            animationData={ModakLoaderAnimation}
            loop
            className="modak-loader"
          />
        </div>
      )}
    </>
  );
};
